import dayjs from "dayjs";
import moment from "moment-timezone"; // eslint-disable-line no-restricted-imports -- deprecated usage
import type * as React from "react";
import { t } from "ttag";

import {
  Tooltip,
} from "antd";

import CS from "metabase/css/core/index.css";
import { Icon } from "metabase/ui";
import type Filter from "metabase-lib/v1/queries/structured/Filter";
import {
  TIME_SELECTOR_DEFAULT_HOUR,
  TIME_SELECTOR_DEFAULT_MINUTE,
  computeFilterTimeRange,
  getTimeComponent,
  isStartingFrom,
  setTimeComponent,
} from "metabase-lib/v1/queries/utils/query-time";

import { Container, Interval, ToggleButton } from "./DatePickerFooter.styled";

type Props = {
  hideTimeSelectors?: boolean;
  maxDateRange?: string | null;
  minStartMonthOffset?: string | null;
  filter: Filter;
  onFilterChange: (filter: any[]) => void;
};

const HAS_TIME_TOGGLE = ["between", "=", "<", ">"];

const getIntervalString = (filter: Filter) => {
  const [start = moment(), end = moment()] = computeFilterTimeRange(filter);
  const formatString =
    start?.year() === end?.year() && start?.year() === moment().year()
      ? "MMM D"
      : "MMM D, YYYY";
  return start.format(formatString) + " - " + end.format(formatString);
};

const DatePickerFooter: React.FC<React.PropsWithChildren<Props>> = ({
  filter,
  onFilterChange,
  hideTimeSelectors,
  maxDateRange,
  minStartMonthOffset,
  children,
}) => {
  const [operator, field, startValue, endValue] = filter;
  console.log("DatePickerFooter",  startValue, endValue,"minStartMonthOffset");

  const isOverMaxRange = (() => {
    if (!startValue || !endValue || !maxDateRange) return false;
    const start = dayjs(startValue);
    const end = dayjs(endValue);
    const diff = end.diff(start, "day");
    return diff > Number(maxDateRange);
  })();

  const isBeforeMinStartDate = (() => {
    if (!startValue || !minStartMonthOffset) return false;
  
    const start = dayjs(startValue);
    const rawMin = dayjs().subtract(Number(minStartMonthOffset), "month");
    const minStartDate =
      rawMin.date() === 1 ? rawMin.startOf("day") : rawMin.add(1, "month").startOf("month");
  
    return start.isBefore(minStartDate, "day");
  })();

  console.log("DatePickerFooter isOverMaxRange", isOverMaxRange);
  
  const { hours, minutes } = getTimeComponent(startValue);

  const enableTimeSelectors = () => {
    const start = setTimeComponent(
      startValue,
      TIME_SELECTOR_DEFAULT_HOUR,
      TIME_SELECTOR_DEFAULT_MINUTE,
    );
    let end;
    if (endValue) {
      end = setTimeComponent(
        endValue,
        TIME_SELECTOR_DEFAULT_HOUR,
        TIME_SELECTOR_DEFAULT_MINUTE,
      );
    }
    if (start) {
      onFilterChange([
        operator,
        field,
        start,
        operator === "between" && !end ? start : end,
      ]);
    }
  };
  const onClickToday = () => {
    const now = dayjs();
    const start = setTimeComponent(
      now.format("YYYY-MM-DD"),
      now.hour(),
      now.minute(),
    );
    onFilterChange([operator, field, start]);
  };
  if (
    operator === "time-interval" &&
    (startValue === "current" || startValue === null)
  ) {
    // Hide it here since "current" picker has a bunch of button shortcuts
    return null;
  }
  const showTimeSelectors =
    !hideTimeSelectors &&
    typeof hours !== "number" &&
    typeof minutes !== "number";
  // let content;
  // if (
  //   HAS_TIME_TOGGLE.indexOf(operator) > -1 &&
  //   showTimeSelectors &&
  //   !isStartingFrom(filter)
  // ) {
  //   content = (
  //     <ToggleButton onClick={enableTimeSelectors} icon="clock">
  //       {t`Add a time`}
  //     </ToggleButton>
  //   );
  // } else if (operator === "time-interval" || isStartingFrom(filter)) {
  //   const interval = getIntervalString(filter);
  //   content = interval ? (
  //     <Interval>
  //       <Icon className={CS.mr1} name="calendar" />
  //       <div>{interval}</div>
  //     </Interval>
  //   ) : null;
  // }

  return (
    <div style={{textAlign:'end',paddingRight:'16px'}}>
    {isBeforeMinStartDate ? (
      // <div style={{color:'#ff0000',marginBottom:'11px',marginTop:'10px'}}>{t`起始日期早于最早日期限制`}</div>
      <div style={{color:'#ff0000',marginBottom:'11px',marginTop:'10px'}}>{t`The start date is earlier than the earliest date limit`}</div>
    ) : isOverMaxRange ? (
      // <div style={{color:'#ff0000',marginBottom:'11px',marginTop:'10px'}}>{t`超出最大日期间隔限制`}</div>
      <div style={{color:'#ff0000',marginBottom:'11px',marginTop:'10px'}}>{t`Maximum date interval limit exceeded`}</div>
    ) : (
      children
    )}
  </div>
  );
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default DatePickerFooter;
